import numeral from 'numeral';
import 'numeral/locales';

import { abbreviate, bytes, exponential, exposedNumeral, ordinal, percentage, separator, currency } from './filters.js';

var vueNumeralFilterInstaller = {
  install: function install(vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$locale = _ref.locale,
        locale = _ref$locale === undefined ? 'en-gb' : _ref$locale;

    numeral.locale(locale);

    vue.filter('abbreviate', abbreviate);
    vue.filter('bytes', bytes);
    vue.filter('exponential', exponential);
    vue.filter('numeral', exposedNumeral);
    vue.filter('ordinal', ordinal);
    vue.filter('percentage', percentage);
    vue.filter('separator', separator);
    vue.filter('currency', currency);
  }
};

export default vueNumeralFilterInstaller;

if (typeof window !== 'undefined' && window.Vue) {
  // eslint-disable-next-line no-undef
  Vue.use(vueNumeralFilterInstaller);
}